import React from 'react';
import { Link } from 'react-router-dom';
import { ArchitectureHero } from '../components/ArchitectureHero';
import { ArchitectureCTA } from '../components/ArchitectureCTA';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { MCPSection } from '../components/MCPSection';
import { PreFlightInterception } from '../components/PreFlightInterception';
import { NotTheaterSection } from '../components/NotTheaterSection';
import { LibrarySection } from '../components/LibrarySection';
import { BeyondSystemPrompt } from '../components/BeyondSystemPrompt';
export function ArchitecturePage() {
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-1339">
      {/* Minimal Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-1340">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-1341">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-1342">
            <Link to="/" data-id="element-1343">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-1344" />
            </Link>
            <Navigation data-id="element-1345" />
          </div>
        </div>
      </header>

      <main data-id="element-1346">
        <ArchitectureHero data-id="element-1347" />
        <BeyondSystemPrompt data-id="element-1348" />
        <LibrarySection data-id="element-1349" />
        <PreFlightInterception data-id="element-1350" />
        <NotTheaterSection data-id="element-1351" />
        <MCPSection data-id="element-1352" />
        <ArchitectureCTA data-id="element-1353" />
      </main>

      <Footer data-id="element-1354" />
    </div>;
}